export const BASE_URL = process.env.REACT_APP_API_URL;
export const MARKETING_APP_URL = process.env.REACT_APP_MARKETING_URL;
export const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY;
